/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaRegistration
 */
export interface MfaRegistration {
    /**
     * 
     * @type {string}
     * @memberof MfaRegistration
     */
    qrCodeString: string;
}

/**
 * Check if a given object implements the MfaRegistration interface.
 */
export function instanceOfMfaRegistration(value: object): value is MfaRegistration {
    if (!('qrCodeString' in value) || value['qrCodeString'] === undefined) return false;
    return true;
}

export function MfaRegistrationFromJSON(json: any): MfaRegistration {
    return MfaRegistrationFromJSONTyped(json, false);
}

export function MfaRegistrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaRegistration {
    if (json == null) {
        return json;
    }
    return {
        
        'qrCodeString': json['qrCodeString'],
    };
}

export function MfaRegistrationToJSON(json: any): MfaRegistration {
    return MfaRegistrationToJSONTyped(json, false);
}

export function MfaRegistrationToJSONTyped(value?: MfaRegistration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qrCodeString': value['qrCodeString'],
    };
}

